<template>
    <div class="mm-sidebar mm-desktop">
        <div class="mm-avatar" :style="{'background-color':user.avatar.color}">{{user.avatar.txt}}</div>
        <div class="mm-name">
            {{user.name}}  {{user.lastname}}
        </div>
        <div class="mm-firm">
            {{user.company}}
        </div>
        <div class="mm-separator"></div>
        <div class="mm-title">Kurzy:</div>
        <div v-for="course in courses" class="mm-course">
            <div class="mm-c-title">
                <router-link :to="{name: 'questionary', params:{id: course.course.id}}" >
                    <b> {{course.course.lang.name}}</b>
                </router-link>
            </div>
            <div class="mm-c-status">
                <div class="mm-c-status-value">
                    <range-slider
                        class="slider mm-progress-slider"
                        min="0"
                        max="100"
                        step="1"
                        v-model="course.course.progress"
                        :disabled="true">
                    </range-slider>
                </div>
            </div>
            <a class="mm-c-link"></a>
        </div>
        <router-link :to="{name: 'questionary_all'}" >
            <b> Dotazníky</b>
        </router-link>
        <router-link :to="{name: 'videozone'}" >
            <b> Videozóna</b>
        </router-link>
    </div>


</template>

<style>
    .mm-progress-slider .range-slider-knob{
        display: none;
    }
</style>

<script>
    import RangeSlider from 'vue-range-slider'


    export default {
        components: {
            RangeSlider
        },
        props: ['user', 'courses'],
        data() {
            return{

            };
        },
        created: () => {

        },
        methods: {

        },
        watch: {

        }
    }
</script>



// WEBPACK FOOTER //
// src/public_app/elements/custom/MmSidebar.vue